import makeStyles from '@mui/styles/makeStyles';
import classNames from "classnames";
import {ChevronDown, Video as VideoIcon} from "lucide-react";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import config from "common/config";
import {color, font, type} from "common/tokens";
import Card from "components/redesign/Card";
import Video from "components/Video";

const useStyles = makeStyles({
  card: {
    padding: 14,
  },
  header: {
    appearance: 'none',
    background: 'none',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    width: '100%',
    padding: 0,
    cursor: 'pointer',
    textAlign: 'left',
  },
  iconWrap: {
    width: 40,
    height: 40,
    borderRadius: 16,
    flexShrink: 0,
    background: color.SURFACE_MUTED,
    color: color.TEXT,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  body: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    ...type.cardHeading,
    color: color.TEXT,
    margin: 0,
  },
  subtitle: {
    ...type.meta,
    fontWeight: font.REGULAR,
    color: color.TEXT_MUTED,
    margin: '2px 0 0',
  },
  chevron: {
    color: color.TEXT_MUTED,
    transition: 'transform 150ms ease',
    flexShrink: 0,
    display: 'flex',
  },
  chevronOpen: {
    transform: 'rotate(180deg)',
  },
  player: {
    marginTop: 12,
  },
});

// The walkthrough the Android home carries, on the web rail: folded away until
// someone says they are stuck.
const WalkthroughCard = ({videoId = config.WALKTHROUGH_VIDEO_ID}) => {
  const classes = useStyles();
  const {t} = useTranslation();
  const [expanded, setExpanded] = useState(false);

  if (!videoId) {
    return null;
  }

  return (
    <Card className={classes.card}>
      <button
        type={'button'}
        className={classes.header}
        aria-expanded={expanded}
        onClick={() => setExpanded(!expanded)}
      >
        <span className={classes.iconWrap}>
          <VideoIcon size={22} strokeWidth={2}/>
        </span>
        <span className={classes.body}>
          <p className={classes.title}>{t('confusedWhatToDo')}</p>
          <p className={classes.subtitle}>{t('watchWalkthrough')}</p>
        </span>
        <span className={classNames(classes.chevron, expanded && classes.chevronOpen)}>
          <ChevronDown size={22} strokeWidth={2}/>
        </span>
      </button>

      {expanded && (
        <div className={classNames(classes.player, 'ui-enter')}>
          <Video videoId={videoId}/>
        </div>
      )}
    </Card>
  );
};

export default WalkthroughCard;
